<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()" [strong]="true" class="tw-font-bold tw-text-[20px]">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="tw-text-center tw-font-bold tw-pl-0">Event Track List</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-list>
    <ion-item
      color="light"
      *ngFor="let event of (events | sortEvents: sortBy: eventTypeFilter); let i = index"
      [attr.data-cy]="'event-item-' + i"
    >
      <ion-label>
        <span [attr.data-cy]="'event-name-' + i">
          {{
            event?.CountryCode
              ? event?.CountryCode === 'US'|| event?.CountryCode === 'CA'
                ? event?.ToteResponse?.EventDetail?.EventName
                : event?.CountryCode + '-' + event?.ToteResponse?.EventDetail?.EventName
              : event?.ToteResponse?.EventDetail?.EventName
          }}
          </span>

          <span [attr.data-cy]="'current-race-' + i">
          {{
            event?.ToteResponse?.EventDetail?.currentRace?.RaceId
            ? '(R'+event?.ToteResponse?.EventDetail?.currentRace?.RaceId+')'
            : ''
          }}
          </span>

          <span [attr.data-cy]="'event-status-' + i">
          {{
            event?.ToteResponse?.EventDetail?.currentRace
              ? (
                  (event?.ToteResponse?.EventDetail?.currentRace)?.RaceStatus
                    | getRaceStatus: (event?.ToteResponse?.EventDetail?.currentRace)?.PostTime: event?.eventName
                    | countdown: event?.eventName | async
                )
              : (event?.ToteResponse?.EventDetail?.EventStatus | getEventStatus)
          }}
          </span>
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>
